module.exports = __webpack_public_path__ + "img/m1.ad76364b.svg";